import gql from 'graphql-tag';

export const GET_HAS_PAST_WEPLOYEE_WITH_SUBMITTED_TIMESHEET = gql`
  query {
    weployer {
      hasPastWeployeeWithSubmittedTimesheet
    }
  }
`;

export default {
  GET_HAS_PAST_WEPLOYEE_WITH_SUBMITTED_TIMESHEET,
};
